// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"574fe3bf","375":"745d5090","403":"93a8a55f","457":"f74625b8","551":"3f6e3e9a"}[chunkId] + ".chunk.js";
};